import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import Vuelidate from 'vuelidate';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueMask from 'v-mask';
import VueRouter from 'vue-router';
import vco from "v-click-outside";
import router from './router/index';
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import VueHtmlToPaper from "vue-html-to-paper";
import 'vue-search-select/dist/VueSearchSelect.css';
// import Vueditor from 'vueditor';
// import 'vueditor/dist/style/vueditor.min.css';


import 'sweetalert2/dist/sweetalert2.min.css';

import "../src/design/app.scss";

import store from '@/state/store';

import App from './App.vue';

import { initFirebaseBackend } from './authUtils';

import i18n from './i18n';

import { configureFakeBackend } from './helpers/fake-backend';

import tinymce from 'vue-tinymce-editor';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.filter('numFormat', numFormat(numeral));

Vue.use(VueMoment, {
  moment,
});


Vue.component(
  'itemlist', () => import('./components/itemlist'),
  'c-button', () => import('./components/c-button'),
  'c-input', () => import('./components/c-input'),
  'c-input-code', () => import('./components/c-input-code'),
  'c-input-area', () => import('./components/c-input-area'),
  'c-input-invalid', () => import('./components/c-input-invalid'),
  'c-select', () => import('./components/c-select'),
  'c-select-search', () => import('./components/c-select-search'),
  'c-select-choose', () => import('./components/c-select-choose'),
  'c-select-browse', () => import('./components/c-select-browse'),
  'c-browse', () => import('./components/c-browse'),
  'c-dropzone', () => import('./components/c-dropzone'),
  'c-partner', () => import('./components/c-partner'),
  'c-loading', () => import('./components/c-loading'),
  'property-fastview', () => import('./components/property-fastview'),
  'term-row', () => import('./components/term-row'),
  'invoice-row', () => import('./components/invoice-row')
);

// Vue.use(VueLoading);

Vue.use(VueHtmlToPaper, {
  name: "_blank",
  specs: ["fullscreen=no", "titlebar=yes", "scrollbars=yes"],
  styles: [
    // "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    // "https://unpkg.com/kidlat-css/css/kidlat.css",
    "http://localhost:8080/css/print.css"
  ]
});

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)
Vue.config.silent = true

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
